import React, { useState } from "react";

import { useNavigate } from "react-router-dom";

// import { Slide } from "react-slideshow-image";
// import "react-slideshow-image/dist/styles.css";

import imageOne from "../../resource/events/annualceremony/2.png";
import imageFour from "../../resource/events/annualceremony/1.png";
import imageFive from "../../resource/events/annualceremony/9.png";
import imageThree from "../../resource/events/annualceremony/8.png";
import imageSix from "../../resource/events/annualceremony/10.png";
import TitleChnage from "../../Hook/TitleChnage";

import wesak from "../../resource/events/annualceremony/3.png";
import aramapoojs from "../../resource/events/annualceremony/4.png";
import kathina from "../../resource/events/annualceremony/6.png";
import pooja from "../../resource/events/annualceremony/7.png";

import { Carousel } from "../Corousel/Carousel";

import data from "../../data/carouselData.json";

const AnnualCeremonies = () => {
  TitleChnage("Annual Ceremony");
  const navigate = useNavigate();

  const [isTextVisible, setIsTextVisible] = useState(false);
  const [isTextVisible1, setIsTextVisible1] = useState(false);
  const [isTextVisible2, setIsTextVisible2] = useState(false);
  const [isTextVisible3, setIsTextVisible3] = useState(false);
  const [isTextVisible4, setIsTextVisible4] = useState(false);

  const handleToggle = () => {
    setIsTextVisible((prev) => !prev);
  };

  const handleToggle1 = () => {
    setIsTextVisible1((prev) => !prev);
  };

  const handleToggle2 = () => {
    setIsTextVisible2((prev) => !prev);
  };

  const handleToggle3 = () => {
    setIsTextVisible3((prev) => !prev);
  };
  const handleToggle4 = () => {
    setIsTextVisible4((prev) => !prev);
  };

  const handleClick = (event) => {
    const pathMap = {
      raintreat: "/raintreat",
      katinaInstructions: "/katinaInstructions",
      sponseringKatina: "/sponseringKatina",
    };

    const path = event.currentTarget.id;
    const targetPath = pathMap[path];

    if (targetPath) {
      navigate(targetPath);
    }
  };
  return (
    <div className="annualevent-page inside-pages">
      <div className="right-box">
        <img
          src={imageOne}
          alt="Right Top Image"
          className="right-image"
          width={300}
        />
      </div>

      <h1 className="font-main dark-gold p-4 mt-4">Annual Ceremonies</h1>
      <h3 className="font-second dark-gold p-4 mt-4">
        Wesak Ceremony..........
      </h3>

      <div className="annual-box mt-6 p-4">
        <div className=" mt-6">
          <Carousel data={data.wesak} />
        </div>

        <p className="mt-6 h4 mb-4">
          <span className="font-second">W</span>esak, the full moon Poya day in
          the month of May, holds profound significance for the Buddhist
          community, commemorating the birth, enlightenment, and passing away
          (Parinibbana) of Lord Buddha. As the most auspicious day of the year,
          the community engages in numerous spiritual activities to honor this
          sacred occasion.
        </p>
      </div>

      <p className="h4 mt-6 p-4">
        The Bhaddeka Vihari Monastery and Meditation Centre not only celebrates
        Wesak Day but also dedicates an entire week to a variety of activities.
        Throughout the week, the Centre shares the teachings of Buddhist
        philosophy, meditation practices, and insights on how these teachings
        can be applied to daily life to foster peace and tranquility. Meditation
        retreats are conducted to help participants experience mental
        tranquility (Samatha) and gain insight into the mind (Vipassana),
        thereby gaining wisdom through the living Dhamma. To further uplift the
        hearts and minds of practitioners, special chanting sessions and
        Buddhist rituals are also performed.
        <span className="lowertext curser-pointer" onClick={handleToggle}>
          {isTextVisible ? "" : "more"}
        </span>
      </p>
      {isTextVisible && (
        <div className="hidden-text">
          <h3 className="font-second dark-gold p-4 mt-6">
            Week-Long Observances:
          </h3>

          <p className="h4 mt-5 p-4">
            Throughout the week leading up to Wesak, the Bhaddeka Vihari
            Monastery and Meditation Centre organizes a series of events aimed
            at deepening the understanding and practice of Buddhist teachings.
            These activities include:
          </p>

          <p className="h4 mt-5 p-4">
            <span className="text-bold">&#x2022; Meditation Retreats</span>:
            Extended meditation sessions, guided by prominent teachers, foster
            mindfulness, inner peace, and spiritual growth. These retreats
            provide an opportunity for participants to withdraw from the
            distractions of daily life and connect deeply with their inner
            selves, experiencing both mental tranquility (Samatha) and insight
            into the nature of the mind (Vipassana). This transformative
            practice helps participants cultivate wisdom through the living
            Dhamma.
          </p>
          <p className="h4 mt-5 p-4">
            <span className="text-bold">&#x2022; Dhamma Talks:</span> Regular
            discourses on the Dhamma (Buddhist teachings) are delivered by
            experienced monks and teachers. These sessions explain how the
            teachings of Buddhism can be applied to one's livelihood to
            experience peace and tranquility. They offer valuable insights into
            Buddhist principles and practical guidance on integrating these
            teachings into everyday life.
          </p>

          <h3 className="font-second dark-gold p-4 mt-6">
            Wesak Day Celebrations::
          </h3>

          <p className="h4 mt-5 p-4">
            On the day of Wesak, a series of special rituals and activities are
            conducted, underscoring the importance of this holy day:
          </p>

          <p className="h4 mt-5 p-4">
            <span className="text-bold">
              &#x2022; Special Rituals and Chanting
            </span>
            : Traditional Buddhist rituals and chanting sessions are performed
            to strengthen the hearts and minds of practitioners, creating a
            serene and sacred atmosphere. These rituals serve as a reminder of
            the profound teachings of the Buddha and the importance of living a
            life of virtue and wisdom.
          </p>

          <p className="h4 mt-5 p-4">
            <span className="text-bold">
              &#x2022; Family Candlelight and Lantern Ceremony
            </span>
            : A particularly notable event during the Wesak celebrations is the
            family candlelight and lantern ceremony. This beautiful tradition
            involves lighting rows of candles and handmade lanterns, symbolizing
            the wisdom and purity of the mind. The ceremony brings warmth and
            brightness to the participants' hearts, fostering a sense of joy and
            unity across all age groups.
          </p>

          <p className="h4 mt-5 p-4">
            <span className="text-bold">
              &#x2022; Ready-to-eat Meal Donation “Dansala”:
            </span>
            On this most auspicious day of the year, the lay community comes
            together to share food with one another in a communal feast. This
            event is organized with the collective service of many hands,
            fostering joy and harmony throughout the community and its
            neighbors.
          </p>

          <p className="h4 mt-5 p-4">
            The Wesak celebrations at the Bhaddeka Vihari Monastery and
            Meditation Centre provide a meaningful opportunity for the Buddhist
            community to come together, honor the life and teachings of the
            Buddha, and engage in practices that promote spiritual growth and
            inner peace.
          </p>

          <p className="h4 mt-5 p-4">
            “The fragrance of flowers or sandalwood cannot go against the wind,
            but the fragrance of virtues pervades all directions.”
          </p>
          <p className="h4 mt-5 p-4">~ Dhammapada, Verse 54</p>
          <p className="h4 mt-4 p-4">
            <span className="lowertext curser-pointer" onClick={handleToggle}>
              {isTextVisible ? "less" : ""}
            </span>
          </p>
          
        </div>
      )}
      <div className="bottom-box mt-6">
            <img src={wesak} alt="bottom-image" width={600} />
          </div>
      <h3 className="font-second dark-gold p-4 mt-6">Arama Pooja..........</h3>

      <div className="annual-box mt-6 p-4">
        <p className="mt-6 h4 mb-4">
          <span className="font-second">A</span>rama Pooja is a significant
          ceremony in the Buddhist tradition, where land is offered to the
          Buddha Sasana for the establishment of a residence for the Sangha.
          This event holds both spiritual and communal importance, as the
          community gains merits by contributing toward a portion of the land.
          Practitioners can then utilize this space for their spiritual journey.
        </p>

        <div className=" mt-6">
          <Carousel data={data.aramapooja} />
        </div>
      </div>

      <p className="h4 mt-6 p-4">
        Offering a piece of land for an Arama may typically be out of reach for
        an individual. However, when the land is divided into smaller plots, it
        becomes more affordable for many devotees. Each devotee can purchase a
        plot valued at $500 and offer it to the Arama, with their contributions
        recorded in a "Sannaspathra". Collectively, these individual
        contributions form the entire land of the Arama.
        <span className="lowertext curser-pointer" onClick={handleToggle1}>
          {isTextVisible1 ? "" : "more"}
        </span>
      </p>

      {isTextVisible1 && (
        <div className="hidden-text">
          <p className="h4 mt-5 p-4">
            The Bhaddeka Vihari Monastery and Meditation Centre organizes an
            annual Arama Pooja Ceremony, during which senior Sangha members,
            especially from Sri Lanka, receive the "Sannaspathra" from the
            devotees. This ceremony provides a valuable opportunity for
            attendees to meet and pay their respects to these esteemed Sangha
            members. In addition to the formalities, participants can listen to
            Dhamma sermons and engage in various activities designed to uplift
            their hearts and minds through the teachings of the Dhamma.
            <span className="lowertext curser-pointer" onClick={handleToggle1}>
              {isTextVisible1 ? "less" : ""}
            </span>
          </p>
        </div>
      )}

      <div className="bottom-box mt-6">
        <img src={aramapoojs} alt="bottom-image" width={600} />
      </div>

      <h3 className="font-second dark-gold p-4 mt-6">
        Kathina Ceremony..........
      </h3>

      <div className="annual-box mt-6 p-4">
        <div className=" mt-6">
          <Carousel data={data.kathinaceremony} />
        </div>
        <p className="mt-6 h4 mb-4">
          <span className="font-second">I</span>n the Buddhist tradition, the
          period from the first full moon Poya day of the month of July to the
          full moon Poya day of October is known as the "Vassa season."
          Historically, this period, which coincides with the rainy season in
          tropical regions during the time of Lord Buddha, is dedicated to
          intensive spiritual practice. During these three months, the Sangha
          (monastic community) remains in a suitable dwelling, focusing on
          secluded spiritual development and setting aside other commitments.
        </p>
      </div>

      <p className="h4 mt-6 p-4">
        Devotees play a crucial role during the Vassa season by preparing
        dwellings for the Sangha and inviting them on the July full moon Poya
        day. This invitation marks a special occasion where the laity pledges to
        support the Sangha throughout the Vassa season by providing meals and
        other necessities. This period is considered highly auspicious in the
        Buddhist calendar, as it allows the Sangha to dedicate themselves to
        spiritual growth, while the community has the opportunity to care for
        their well-being and accumulate merits.
        <span className="lowertext curser-pointer" onClick={handleToggle2}>
          {isTextVisible2 ? "" : "more"}
        </span>
      </p>

      {isTextVisible2 && (
        <div className="hidden-text">
          <p className="h4 mt-5 p-4">
            Throughout the Vassa season, special Dhamma talks are organized to
            support the spiritual growth of the community. These talks provide
            valuable insights and guidance, enriching the spiritual journey of
            both the Sangha and the laity.
          </p>
          <p className="h4 mt-5 p-4">
            At the conclusion of the Vassa season, the community organizes the
            Kathina Ceremony, a significant event where offerings are made to
            the Sangha. The highlight of this ceremony is the preparation and
            offering of a special robe known as the "Kathina Chivara." This
            auspicious occasion is seen as an opportunity for devotees to gain
            merit and blessings by offering various items, including robes, to
            the Sangha.
          </p>
          <p className="h4 mt-5 p-4">
            The act of offering the Kathina Chivara and other necessities during
            the Kathina Ceremony is believed to bring numerous benefits,
            including health, long life, physical and mental strength, wisdom,
            and more.
          </p>
          <p className="h4 mt-5 p-4">
            All special dates related to the Vassa season and the Kathina
            Ceremony will be published in the Event Calendar available on this
            website, ensuring that the community remains informed and engaged.
          </p>
          <p className="h4 mt-5 p-4">
            The Kathina Ceremony at Bhaddeka Vihari Monastery and Meditation
            Centre is a deeply meaningful event that underscores the mutual
            support between the Sangha and the laity, fostering spiritual growth
            and communal harmony.
            <span className="lowertext curser-pointer" onClick={handleToggle2}>
              {isTextVisible2 ? "less" : ""}
            </span>
          </p>
        </div>
      )}

      <section className="button-section-hermitage page2">
        <div className="left-col">
          <img
            src={imageFour}
            alt=""
            width={300}
            id="sponseringKatina"
            onClick={handleClick}
          />
          <img
            src={imageFive}
            alt=""
            width={300}
            onClick={handleClick}
            id="raintreat"
          />
        </div>

        <div className="right-col">
          <img
            src={imageSix}
            alt=""
            width={300}
            id="katinaInstructions"
            onClick={handleClick}
          />
        </div>
      </section>

      <div className="bottom-box">
        <img src={kathina} alt="bottom-image" width={600} />
      </div>

      <h3 className="font-second dark-gold p-4 mt-6">
        Guru Banda Pooja Ceremony..........
      </h3>

      <div className="annual-box mt-6 p-4">
        <p className="mt-6 h4 mb-4">
          <span className="font-second">T</span>he Garu Bhanda Pooja is a
          significant ceremony dedicated to offering essential items and
          equipment necessary for the livelihood of Buddhist practitioners.
          Derived from the words "Garu" (venerate), "Bhanda" (items), and
          "Pooja" (act of worship), this event exemplifies the mutual support
          between donors and practitioners.
        </p>
        <div className=" mt-6">
          <Carousel data={data.poojaceremony} />
        </div>
      </div>

      <p className="h4 mt-6 p-4">
        Any commonly used item by practitioners is categorized as "Garu Bhanda,"
        regardless of its size. The Garu Bhanda Pooja Ceremony at the Bhaddeka
        Vihari Monastery and Meditation Centre has been organized annually since
        2017. The process begins with the identification of essential items
        needed for our Centre, Ripplebrook and various hermitages in Sri Lanka.
        These items are then listed with their costs and published for the
        community. Donors can either purchase the items individually or
        contribute to a collective fund to offer them as a group during the
        ceremony. This method ensures that donors provide only the essential
        items, avoiding unnecessary expenditures. Additionally, expensive items
        that may be difficult for an individual donor to afford can be purchased
        through multiple contributions.
        <span className="lowertext curser-pointer" onClick={handleToggle3}>
          {isTextVisible3 ? "" : "more"}
        </span>
      </p>
      {isTextVisible3 && (
        <div>
          <p className="h4 mt-5 p-4">
            Despite ongoing construction at the Meditation Centre, teaching
            activities, retreats, and ceremonies continue using the available
            infrastructure. To support these efforts, substantial ongoing
            funding is required for equipment, furniture, work tools, fittings,
            coverings, building materials, decorative items, and more.
          </p>

          <p className="h4 mt-5 p-4">
            The Sri Lankan hermitages also appreciate the use of these pooja
            items, including some high-tech equipment that is not readily
            available or affordable within the country. These items make
            construction and maintenance work much easier and faster.
          </p>

          <p className="h4 mt-5 p-4">
            Whenever these items are used, the donors receive heartfelt
            gratitude from the practitioners, accumulating merits and giving
            full meaning to the term "Garu Bhanda". By participating in the Garu
            Bhanda Pooja, both donors and practitioners contribute to the
            flourishing of the Buddha Sasana and the spiritual growth of the
            community.
            <span className="lowertext curser-pointer" onClick={handleToggle3}>
              {isTextVisible3 ? "less" : ""}
            </span>
          </p>
        </div>
      )}
      <div className="bottom-box mt-6">
        <img src={pooja} alt="bottom-image" width={600} />
      </div>

      <h3 className="font-second dark-gold p-4 mt-6">
        New Year Celebrations..........
      </h3>

      <div className="annual-box mt-6 p-4">
        <div className=" mt-6">
          <Carousel data={data.newyearcelebrations} />
        </div>
        <p className="mt-6 h4 mb-4">
          <span className="font-second">T</span>he Bhaddeka Vihari Monastery and
          Meditation Centre celebrates the first day of the calendar year on
          January 1st with great reverence. The Centre graciously organizes a
          variety of activities for individuals of all age groups, aiming to
          begin the New Year with a firm commitment to enhancing livelihoods for
          the benefit of both individuals and the community, thus fostering
          happiness and peace.
        </p>
      </div>

      <p className="h4 mt-6 p-4">
        These auspicious days are marked by events such as meditation sessions,
        Dhamma talks, and group discussions. These activities help participants
        understand the importance of integrating the Dhamma into daily life,
        encouraging them to structure their spiritual and communal practices
        throughout the year. This creates a serene and harmonious atmosphere,
        which supports participants in achieving their aspirations.
        Additionally, special chanting events and Buddhist rituals are conducted
        to bestow blessings upon the community’s well-being.
        <span className="lowertext curser-pointer" onClick={handleToggle4}>
          {isTextVisible4 ? "" : "more"}
        </span>
      </p>
      {isTextVisible4 && (
        <p className="h4 mt-5 p-4">
          A particularly significant event for families is the Candlelight
          Ceremony, during which rows of candles are lit to symbolize the wisdom
          and purity of the mind. This ceremony brings warmth and brightness to
          the hearts of all participants, evoking joy across all age groups.
          <span className="lowertext curser-pointer" onClick={handleToggle4}>
            {isTextVisible4 ? "less" : ""}
          </span>
        </p>
      )}

      <div className="bottom-box mt-6">
        <img src={imageThree} alt="bottom-image" width={600} />
      </div>
    </div>
  );
};

export default AnnualCeremonies;
